import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msal-config';

/**
 * Instância ÚNICA do MSAL, compartilhada entre o MsalProvider (App.tsx) e o client HTTP
 * (lib/api/client.ts). Ter uma só instância garante que o client enxergue a conta logada
 * pelo provider — caso contrário a aquisição de token silenciosa não acha conta nenhuma.
 */
export const msalInstance = new PublicClientApplication(msalConfig);

let initPromise: Promise<void> | null = null;

/**
 * Garante um único initialize() (msal-browser ≥ 3 exige initialize antes de qualquer uso).
 * Idempotente — chamadas concorrentes compartilham a mesma promise.
 */
export function ensureMsalInitialized(): Promise<void> {
  initPromise ??= msalInstance.initialize();
  return initPromise;
}
